import { ViewerModal } from "Components/ViewerModal";
import { observer } from "mobx-react";
import { ViewerType, viewFileFullscreen } from "Pages/ViewFullscreen/viewFileFullscreen";
import { projectsDataStore } from "Stores/ProjectsStore";
import { xktViewerStore } from "./Stores/XKTViewerStore";
import { XKTViewer } from "./XKTViewer";
import { BcfSidebarContextProvider } from "./Components/BCF/BcfSidebarContext";

export const XKTViewerModal = observer(() => {
  const doFullscreen = () => {
    const fileId = xktViewerStore.fileId;
    const viewFileFullScreenProps = {
      projectId: projectsDataStore.projectId,
      fileId: fileId,
      viewerType: ViewerType.XV,
      fileName: xktViewerStore.fileName,
    };
    xktViewerStore.hide();
    viewFileFullscreen(viewFileFullScreenProps);
  };

  return (
    <ViewerModal
      title={xktViewerStore.fileName}
      visible={xktViewerStore.isVisible}
      onCancel={xktViewerStore.hide}
      onFullScreen={doFullscreen}
      forceRender={false}
      escToClose={false}
      zIndex={1060}
      destroyOnHidden={true}
    >
      <BcfSidebarContextProvider>
        <XKTViewer />
      </BcfSidebarContextProvider>
    </ViewerModal>
  );
});
